/**
 * SuggestionScoff
 * 
 * @Author: Focci
 * @Date: 2023-09-29 14:48:45
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-29 14:48:45
 */

import PropTypes from 'prop-types'

export default function SuggestionScoff({
  label = '',
  children
}) {
  return (
    <div className="w-full">
      <div className="text-f.7 text-meta font-medium">
        {label}
      </div>
      <div className="flex flex-wrap gap-1 mt-2">
        {children}
      </div>
    </div>
  )
}

SuggestionScoff.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
}
